module.exports = __webpack_public_path__ + "static/media/gts36.f0cc7b96.png";